import { IGlobalAlert } from '../@types/global-alert';
import { axios } from '../utils/axios';

export async function getGlobalAlert() {
  const { data } = await axios.get<IGlobalAlert[]>('/alert');
  return data;
}

export * as GlobalAlertRequests from './global-alert';
